import React from 'react';
import { Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    padding: '15px 0',
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Divider />
    </div>
  );
};
